export default __webpack_public_path__ + "17585f04de15b11b4fb7f3c3ba900c77.webp";